// src/services/articlesPagesServices.js

import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/articlespages`;

const getAuthHeaders = () => {
  const token = localStorage.getItem("token");

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
};

/// GET
// Récupérer tous les articles d'une page
export const getAllArticlesByPage = async (pageId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/getAllArticlesByPage/${pageId}`,
      {
        headers: getAuthHeaders(),
      }
    );

    if (response.status !== 200) {
      throw new Error("Failed to fetch articles");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des articles :", error);
    return [];
  }
};

// Récupérer un article par son id
export const getArticlePageById = async (id) => {
  try {
    const response = await axios.get(`${apiUrl}/getArticleById/${id}`, {
      headers: getAuthHeaders(),
    });

    if (response.status !== 200) {
      throw new Error("Failed to fetch article");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement de l'article :", error);
    return null;
  }
};

/// POST
// Ajouter un article à une page
export const addArticlePage = async (newArticle) => {
  try {
    const response = await axios.post(`${apiUrl}/addArticle`, newArticle, {
      headers: getAuthHeaders(),
    });

    if (response.status !== 201) {
      throw new Error("Failed to add article");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout d'un article :", error);
    return null;
  }
};

/// PUT
// Modifier un article
export const updateArticlePage = async (article) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateArticle/${article.id}`,
      article,
      {
        headers: getAuthHeaders(),
      }
    );

    if (response.status !== 200) {
      throw new Error("Failed to update article");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification d'un article :", error);
    return null;
  }
};

/// PATCH
// Modifier uniquement l'ordre d'un article
export const updateArticlePageOrder = async (id, ordre) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/updateArticleOrder/${id}`,
      { ordre },
      {
        headers: getAuthHeaders(),
      }
    );

    if (response.status !== 200) {
      throw new Error("Failed to update article order");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification de l'ordre de l'article :", error);
    return null;
  }
};

/// DELETE
// Supprimer un article
export const deleteArticlePage = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/deleteArticle/${id}`, {
      headers: getAuthHeaders(),
    });

    if (response.status !== 200) {
      throw new Error("Failed to delete article");
    }

    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression d'un article :", error);
    return null;
  }
};